import create from 'zustand';
import { Request } from '../models/Request';

interface UserRequestStoreState {
  requests: Request[] | undefined;
  setRequests: (requests: Request[]) => void;
}

export const useUserRequestStore = create<UserRequestStoreState>((set) => {
  return {
    requests: undefined,
    setRequests: (requests: Request[]) => set({ requests }),
  };
});
